import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=4d15b4a7&"
import script from "./ContactView.vue?vue&type=script&lang=ts&"
export * from "./ContactView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports